/*
Copyright (c) 2021, Company Cpyright header.
*/

import { createStore, applyMiddleware, compose, legacy_createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import configureStore from 'redux-mock-store';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { devToolsEnhancer } from 'redux-devtools-extension';

import rootSaga from '../sagas';
import reducer from '../reducers/index';
const persistConfig = {
  key: 'root',
  storage
};
const composeEnhancers =
  (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 })) ||
  compose;

const persistedReducer = persistReducer(persistConfig, reducer);

const sagaMiddleware = createSagaMiddleware();

export const Store = createStore(persistedReducer, composeEnhancers(applyMiddleware(sagaMiddleware)));
//export const Store = createStore(persistedReducer, compose(applyMiddleware(sagaMiddleware),devToolsEnhancer()));

sagaMiddleware.run(rootSaga);
export const persistor = persistStore(Store);
export const getMockStoreProvider = initialState => {
  const middlewares = [];
  const mockStore = configureStore(middlewares);
  const store = mockStore(initialState);
  const MockStoreProvider = ({ children }) => <Provider store={store}>{children}</Provider>;
  MockStoreProvider.propTypes = {
    children: PropTypes.any
  };
  MockStoreProvider.defaultProps = {
    children: undefined
  };
  return { store, MockStoreProvider };
};
